export enum LoginProvider {
  Email = "email",
  Apple = "apple",
  Facebook = "facebook",
  Google = "google",
}
